<div class="container-fluid mt-topnav pt-3">
    <!-- <app-alertbox [@inbgOutAnimation] [alerticon]="'arrow_forward'" [alertdisplay]="'modal'" [alerttype]="'comment'"
        [alerttext]="'fileupload.fileuploaddelete' | trans "></app-alertbox>-->
    <app-customerwelcome [quill]="true"></app-customerwelcome> 
    <app-cpl-list></app-cpl-list>
</div>